"use client";;
import * as React from "react";
import { Drawer as DrawerPrimitive } from "vaul";

import { CardClass_BLUE_colors, cn } from "@/lib/utils";
import { CardRawClass } from "./card";

const Drawer = ({
  shouldScaleBackground = true,
  ...props
}: React.ComponentProps<typeof DrawerPrimitive.Root>) => (
  <DrawerPrimitive.Root
    shouldScaleBackground={ shouldScaleBackground }
    { ...props }
  />
)
Drawer.displayName = "Drawer"

const DrawerTrigger = DrawerPrimitive.Trigger

const DrawerPortal = DrawerPrimitive.Portal

const DrawerClose = DrawerPrimitive.Close

const DrawerOverlay = React.forwardRef<
  React.ElementRef<typeof DrawerPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Overlay>
>(({ className, ...props }, ref) => (
  <DrawerPrimitive.Overlay
    ref={ ref }
    className={ cn("fixed inset-0 z-50 bg-black/80", className) }
    { ...props }
  />
))
DrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName

const DrawerContent = React.forwardRef<
  React.ElementRef<typeof DrawerPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <DrawerPortal>
    <DrawerOverlay />
    <DrawerPrimitive.Content
      ref={ ref }
      className={ cn(
        CardRawClass, CardClass_BLUE_colors, "rounded-none shadow-none ring-0 m-0 sm:m-0 border-0 border-t-4  backdrop-blur-xl bg-slate-800/60",
        "after:!bg-slate-900",
        "fixed inset-x-0 w-full bottom-0 z-50 mt-24  sm:px-8 flex h-auto flex-col rounded-t-2xl",
        className
      ) }
      { ...props }
    >
      <div className="mx-auto mt-4 h-2 w-[100px] rounded-full bg-nfBlue-600" />
      { children }
    </DrawerPrimitive.Content>
  </DrawerPortal>
))
DrawerContent.displayName = "DrawerContent"

const DrawerHeader = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={ cn("grid gap-1.5 p-1 text-center", className) }
    { ...props }
  />
)
DrawerHeader.displayName = "DrawerHeader"

const DrawerFooter = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={ cn("mt-auto flex flex-col gap-2 p-1", className) }
    { ...props }
  />
)
DrawerFooter.displayName = "DrawerFooter"

const DrawerTitle = React.forwardRef<
  React.ElementRef<typeof DrawerPrimitive.Title>,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Title>
>(({ className, ...props }, ref) => (
  <DrawerPrimitive.Title
    ref={ ref }
    className={ cn(
      "font-semibold leading-none tracking-tight text-4xl",
      className
    ) }
    { ...props }
  />
))
DrawerTitle.displayName = DrawerPrimitive.Title.displayName

const DrawerDescription = React.forwardRef<
  React.ElementRef<typeof DrawerPrimitive.Description>,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Description>
>(({ className, ...props }, ref) => (
  <DrawerPrimitive.Description
    ref={ ref }
    className={ cn("text-sm  text-nfBlue-200", className) }
    { ...props }
  />
))
DrawerDescription.displayName = DrawerPrimitive.Description.displayName

export {
  Drawer, DrawerClose,
  DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerPortal, DrawerTitle, DrawerTrigger
};

